import {h, Fragment} from "preact"
export default function SubmitButton({ className, text, handleSubmit }) {
    return (
        <div className={`ns-autocomplete-submit ns-d-flex ns-justify-content-center ${className}`}>
            <button type="submit" className="ns-act-btn ns-text-align-center ns-w-100" onClick={(e)=>handleSubmit(e)}>
                {text}<span><svg class="icon icon-arrow-right icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="graphics-symbol" focusable="false">
                        <title>Arrow Right</title>
                        <path d="M13 7L18 12M13 17L18 12M18 12H6" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </span>
            </button>
        </div>
    )
}